/**
 * Created by shobhitjain on 27/12/19.
 */

import React, { Component } from 'react';
import TableHeader from '../../../../components/TableHeader/index';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './index.scss';
import Table from './Table/index';
import TableRows from './TableRows/TableRows';

/**
 * TookiTakiTable component
 */
class TookiTakiTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chevronUp: false
    };
  }

  toggleTable = () => {
    this.setState({ chevronUp: !this.state.chevronUp }, () => {
      this.props.isExpanded(this.state.chevronUp);
    });
  };

  render() {
    const { chevronUp } = this.state;
    const { title, data, header } = this.props;
    return (
      <div>
        <div className={classnames(style.card, 'mt-3')}>
          <div
            onClick={this.toggleTable}
            className={classnames(
              style.card_header,
              'd-flex',
              'align-items-center',
              chevronUp ? style.border_radius_bottom_zero : ''
            )}
            style={{ cursor: 'pointer' }}>
            <div>
              <span>{title}</span>
            </div>
            <i
              className={classnames(
                style.icon14,
                chevronUp
                  ? style.icon14_icon_arrow_up
                  : style.icon14_icon_arrow_down,
                'ml-auto'
              )}
              aria-hidden="true"
            />
          </div>
          {chevronUp && (
            <div className={style.collapsed} id="collapseExample">
              <div
                className={classnames(
                  style.card_body,
                  'p-0',
                  data.length > 0 ? style.height_class : ''
                )}>
                <Table>
                  {data.length > 0 && <TableHeader data={header} />}
                  <TableRows keys={header} data={data} />
                </Table>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

/**
 * Proptypes
 * @type {{data: shim, header: shim, title: shim}}
 */
TookiTakiTable.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  header: PropTypes.array.isRequired
};
/**
 * Default props
 * @type {{data: [], header: []}}
 */
TookiTakiTable.defaultProps = {
  data: [],
  header: []
};

export default TookiTakiTable;
